/* global jQuery, elementorFrontend */

jQuery( window ).on( 'elementor/frontend/init', () => {

	/**
	* MTD Slider
	* Set up swiper.js instance for the MTD Slider widget
	*
	* @param $element The widget wrapper element as a jQuery element
	* @param $ The jQuery alias
	*/
	const mtdSliderHandler = ( $element, $ ) => {
		const asyncSwiper = elementorFrontend.utils.swiper;
		$element.find('.mtd-slider__slider').each(function() {
			let $this = $(this);
			let slideCount = $this.find('.slide-entry-container').length;
			
			if( slideCount >= 1 ) {
				let dataID = $element.data('id');
				let columnCount = $this.data('columncount');
				let slideVisibility = $this.data('slidevisibility');

				let centeredSlides, slidesPerViewAddon;

				if( slideVisibility == 'normal' ) {
					centeredSlides = false;
					slidesPerViewAddon = 0;
				} else if( slideVisibility == 'partial' ) {
					centeredSlides = false;
					slidesPerViewAddon = .3;
				} else if( slideVisibility == 'partialcentered' ) {
					centeredSlides = true;
					slidesPerViewAddon = .3;
				}

				var swiperSettings = {
					allowTouchMove: true,
					centeredSlides: centeredSlides,
					// centerInsufficientSlides: true,
					loop: false,
					slidesPerView: 1,
					spaceBetween: 32,
					speed: 350,
					navigation: {
						nextEl: $element.find('.mtd-slider__next')[0],
						prevEl: $element.find('.mtd-slider__prev')[0]
					},
					watchOverflow: true,
					breakpoints: {
						481: {
							// allowTouchMove: false,
							preventClicks: false,
							preventClicksPropagation: false,
							preventInteractionOnTransition: true,
							slidesPerView: Math.max( (columnCount - 2), 1),
							spaceBetween: 24
						},
						768: {
							// allowTouchMove: false,
							preventClicks: false,
							preventClicksPropagation: false,
							preventInteractionOnTransition: true,
							slidesPerView: Math.max( (columnCount - 1), 1) + slidesPerViewAddon,
							spaceBetween: 24
						},
						980: {
							// allowTouchMove: true,
							preventClicks: false,
							preventClicksPropagation: false,
							preventInteractionOnTransition: true,
							slidesPerView: columnCount  + slidesPerViewAddon,
							spaceBetween: 24
						}
					},
					pagination: {
						clickable: true,
						el: $element.find('.mtd-slider__pagination')[0],
						type: 'bullets'
					}
				};
				
				window["mtdSwiper_"+dataID] = new asyncSwiper($this, swiperSettings);
			}
		});
	};

	elementorFrontend.hooks.addAction( 'frontend/element_ready/mtd-slider.default', mtdSliderHandler );


	/**
	* MTD Mobile Menu
	*
	* @param $element The widget wrapper element as a jQuery element
	* @param $ The jQuery alias
	*/
	const mtdMenuHandler = ( $element, $ ) => {
		let button = $element.find('.mtd-mobilemenu-open'),
		close = $element.find('.mtd-mobilemenu-close'),
		parent = $element.find('.mtd-mobilemenu');

		console.log(parent);

		button.click(function(e){
			parent.addClass('active');
		});

		close.click(function(e){
			parent.removeClass('active');
		});
	};

	elementorFrontend.hooks.addAction( 'frontend/element_ready/mtd-mobilemenu.default', mtdMenuHandler );
	

} );